import { render } from "./DropdownMenuHeading.vue?vue&type=template&id=c2f7b172"
const script = {}

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DropdownMenuHeading.vue"]])

export default __exports__